import { render, staticRenderFns } from "./TemplateListPage.vue?vue&type=template&id=a135a098&scoped=true"
import script from "./TemplateListPage.vue?vue&type=script&lang=js"
export * from "./TemplateListPage.vue?vue&type=script&lang=js"
import style0 from "./TemplateListPage.vue?vue&type=style&index=0&id=a135a098&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a135a098",
  null
  
)

export default component.exports